import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";
import ChiTietTaiSanContainer from "containers/Common/TaiSan/ChiTietTaiSanContainer";

class ListTaiSanCamCoView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
      showModalTaiSan: false,
      taiSanId: 0,
    };
  }
  setModalTaiSan = (taiSanId) => () => {
    let { showModalTaiSan } = this.state;
    this.setState({ taiSanId, showModalTaiSan: !showModalTaiSan });
  };
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    // let { setModalTaiSan } = this.props;
    return List.map((item, index) => {
      let { Code, TenTaiSan, PhiKho, Note, TaiSanID } = item;
      return (
        <tr className="" key={"camCo-" + index}>
          <td>{index + 1}</td>
          {/* <td className="text-left">
            <div className="img-taisan">
              <img alt="" src="/app-assets/images/vespa.jpg" />
              <img alt="" src="/app-assets/images/vespa.jpg" />
            </div>
          </td> */}
          <td className="text-left">
            <p onClick={this.setModalTaiSan(TaiSanID)} className="color-xanh-bold btn-link">
            {Code}
            </p>
          </td>
          <td className="text-left">{TenTaiSan}</td>
          <td className="text-right">{formatNumber(PhiKho)}</td>
          <td className="text-left">{Note}</td>
        </tr>
      );
    });
  }
  render() {
    let { TongTien, List } = this.props;
    let { taiSanId, showModalTaiSan } = this.state;
    return (
      <div className="table-from-detailtl2">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover table-rounded">
              <thead>
                <tr>
                  <th className="w-5">STT</th>
                  {/* <th className="text-left w-25">Ảnh tài sản</th> */}
                  <th className="text-left w-15">Mã tài sản</th>
                  <th className="text-left w-15">Tên tài sản</th>
                  <th className="text-right w-10">
                    Phí kho
                    <br />
                    <span className="">{formatNumber(TongTien)}</span>
                  </th>
                  <th className="text-left">Ghi chú</th>
                </tr>
              </thead>
              <tbody>{this.renderRow(List)}</tbody>
            </table>
          </div>
        </div>
        {showModalTaiSan && (
          <ChiTietTaiSanContainer
            show={showModalTaiSan}
            taiSanId={taiSanId}
            onHide={this.setModalTaiSan()}
          ></ChiTietTaiSanContainer>
        )}
        {/* <div className="footer-page-new">
          <div className="col-xl-12 col-lg-12">
            <div class="paniation-new d-flex just-end">
              <nav aria-label="Page navigation">
                <Pagination
                  activePage={dataSearch.pageIndex}
                  itemsCountPerPage={dataSearch.pageSize}
                  totalItemsCount={TotalQuantity}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                />
              </nav>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}
export default ListTaiSanCamCoView;
